(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offer-crest-home"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-oc-carousel]').forEach((carousel) => {
    const slides = Array.from(carousel.querySelectorAll('[data-oc-slide]'));
    const dots = Array.from(carousel.querySelectorAll('[data-oc-dot]'));
    const previous = carousel.querySelector('[data-oc-prev]');
    const next = carousel.querySelector('[data-oc-next]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let activeIndex = 0;
    let timer;
    let isVisible = true;

    const showSlide = (index) => {
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === activeIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
      });
      dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', String(isActive));
      });
    };

    const stop = () => {
      window.clearInterval(timer);
    };

    const start = () => {
      stop();
      if (!reduceMotion && isVisible && document.visibilityState === 'visible') {
        timer = window.setInterval(() => showSlide(activeIndex + 1), 4000);
      }
    };

    previous.addEventListener('click', () => {
      showSlide(activeIndex - 1);
      start();
    });
    next.addEventListener('click', () => {
      showSlide(activeIndex + 1);
      start();
    });
    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        showSlide(Number(dot.dataset.ocDot));
        start();
      });
    });
    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('mouseleave', start);
    carousel.addEventListener('focusin', stop);
    carousel.addEventListener('focusout', start);

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        isVisible = Boolean(entries[0]?.isIntersecting);
        if (isVisible) start();
        else stop();
      }, { threshold: 0.05 });
      observer.observe(carousel);
    }

    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') start();
      else stop();
    }, { passive: true });
    start();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offer-crest-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-product-section]').forEach((section) => {
    if (section.dataset.galleryEnhanced === 'true') return;
    section.dataset.galleryEnhanced = 'true';

    const mediaItems = Array.from(section.querySelectorAll('[data-gallery-media]'));
    const thumbnails = Array.from(section.querySelectorAll('[data-gallery-thumbnail]'));
    const counter = section.querySelector('[data-gallery-counter]');
    const galleryStage = section.querySelector('.oc-product-gallery__stage');
    let activeIndex = mediaItems.findIndex((item) => item.classList.contains('is-active'));
    if (activeIndex < 0) activeIndex = 0;

    const syncVideoPlayback = () => {
      mediaItems.forEach((item, itemIndex) => {
        const video = item.querySelector('video');
        if (!video) return;

        if (itemIndex === activeIndex && !item.hidden && document.visibilityState === 'visible') {
          video.muted = true;
          const playback = video.play();
          if (playback && typeof playback.catch === 'function') playback.catch(() => {});
        } else {
          video.pause();
        }
      });
    };

    const renderMedia = (index) => {
      if (!mediaItems.length) return;
      activeIndex = (index + mediaItems.length) % mediaItems.length;
      mediaItems.forEach((item, itemIndex) => {
        const isActive = itemIndex === activeIndex;
        item.hidden = !isActive;
        item.classList.toggle('is-active', isActive);
      });
      thumbnails.forEach((thumb, thumbIndex) => {
        const isActive = thumbIndex === activeIndex;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-selected', String(isActive));
        if (isActive) {
          const strip = thumb.parentElement;
          const isOutsideStrip = strip && (
            thumb.offsetLeft < strip.scrollLeft
            || thumb.offsetLeft + thumb.offsetWidth > strip.scrollLeft + strip.clientWidth
          );
          if (isOutsideStrip) thumb.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'nearest' });
        }
      });
      if (counter) counter.textContent = `${activeIndex + 1} / ${mediaItems.length}`;
      syncVideoPlayback();
    };

    const activateMedia = (index) => {
      renderMedia(index);
    };

    thumbnails.forEach((thumb) => {
      thumb.addEventListener('click', () => activateMedia(Number(thumb.dataset.mediaIndex)));
    });

    section.querySelector('[data-gallery-previous]')?.addEventListener('click', () => activateMedia(activeIndex - 1));
    section.querySelector('[data-gallery-next]')?.addEventListener('click', () => activateMedia(activeIndex + 1));

    let touchStartX = 0;
    galleryStage?.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0]?.clientX || 0;
    }, { passive: true });
    galleryStage?.addEventListener('touchend', (event) => {
      const touchEndX = event.changedTouches[0]?.clientX || 0;
      const distance = touchEndX - touchStartX;
      if (Math.abs(distance) < 44) return;
      activateMedia(activeIndex + (distance < 0 ? 1 : -1));
    }, { passive: true });

    if ('IntersectionObserver' in window && galleryStage) {
      const galleryObserver = new IntersectionObserver((entries) => {
        if (entries[0]?.isIntersecting) {
          syncVideoPlayback();
        } else {
          mediaItems.forEach((item) => item.querySelector('video')?.pause());
        }
      }, { threshold: 0.15 });
      galleryObserver.observe(galleryStage);
    }

    document.addEventListener('visibilitychange', syncVideoPlayback, { passive: true });

    const select = section.querySelector('[data-variant-select]');
    const variantCards = Array.from(section.querySelectorAll('[data-variant-card]'));
    const price = section.querySelector('[data-product-price] strong');
    const compare = section.querySelector('[data-product-price] s');
    const saleBadge = section.querySelector('[data-sale-badge]');
    const offerKicker = section.querySelector('[data-offer-kicker]');
    const stickyPrice = section.querySelector('[data-sticky-price]');
    const addButtons = section.querySelectorAll('[data-add-button]');
    const addLabel = section.dataset.addLabel;
    const soldLabel = section.dataset.soldLabel;
    const packageOption = section.querySelector('[data-package-option]');
    const sku = section.querySelector('[data-product-sku]');

    if (select) {
      const syncVariant = ({ updateUrl = true, activateVariantMedia = true } = {}) => {
        const option = select.options[select.selectedIndex];
        const available = option.dataset.available === 'true';
        const compareValue = option.dataset.compare;
        const saveValue = option.dataset.save;

        if (price) price.textContent = option.dataset.price;
        if (stickyPrice) stickyPrice.textContent = option.dataset.price;
        if (compare) {
          compare.textContent = compareValue;
          compare.hidden = !compareValue;
        }
        if (saleBadge) {
          saleBadge.textContent = saveValue;
          saleBadge.hidden = !saveValue;
        }
        if (offerKicker) offerKicker.hidden = section.dataset.isStarProjector === 'false' && !saveValue;
        if (packageOption) packageOption.textContent = option.textContent.replace('— Sold out', '').trim();
        if (sku) sku.textContent = option.dataset.sku || '—';

        variantCards.forEach((card) => {
          const isSelected = card.dataset.variantId === option.value;
          card.classList.toggle('is-selected', isSelected);
          card.setAttribute('aria-checked', String(isSelected));
          card.tabIndex = isSelected ? 0 : -1;
        });

        addButtons.forEach((button) => {
          button.disabled = !available;
          button.textContent = available ? addLabel : soldLabel;
        });

        if (activateVariantMedia && option.dataset.media) {
          const targetIndex = mediaItems.findIndex((item) => item.dataset.mediaId === option.dataset.media);
          if (targetIndex >= 0) activateMedia(targetIndex);
        }

        if (updateUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', option.value);
          window.history.replaceState({}, '', url);
        }
      };

      select.addEventListener('change', () => syncVariant());

      variantCards.forEach((card) => {
        card.addEventListener('click', () => {
          if (card.disabled) return;
          select.value = card.dataset.variantId;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });

        card.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) return;
          event.preventDefault();
          const availableCards = variantCards.filter((item) => !item.disabled);
          const currentIndex = availableCards.indexOf(card);
          const direction = event.key === 'ArrowRight' || event.key === 'ArrowDown' ? 1 : -1;
          const nextCard = availableCards[(currentIndex + direction + availableCards.length) % availableCards.length];
          nextCard.click();
          nextCard.focus();
        });
      });

      const linkedVariantId = new URL(window.location.href).searchParams.get('variant');
      const linkedVariant = linkedVariantId
        ? Array.from(select.options).find((option) => option.value === linkedVariantId)
        : null;

      if (linkedVariant) {
        select.value = linkedVariant.value;
        syncVariant({ updateUrl: false, activateVariantMedia: true });
      } else {
        syncVariant({ updateUrl: false, activateVariantMedia: false });
        renderMedia(activeIndex);
      }
    } else {
      renderMedia(activeIndex);
    }

    const quantityInput = section.querySelector('[data-quantity-input]');
    section.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
      quantityInput.value = Math.max(1, Number(quantityInput.value || 1) - 1);
    });
    section.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
      quantityInput.value = Math.max(1, Number(quantityInput.value || 1) + 1);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
